import type { ProfitLeak } from '../estimate.types';

export function getLeakMessage(leak: ProfitLeak): string {
  switch (leak.type) {
    case "primer":
      return "Brak gruntu = ryzyko odparzeń i poprawek na własny koszt.";
    case "hydro":
      return "Brak hydro = ryzyko zalania i reklamacji.";
    case "acrylic":
      return "Brak akrylu = pęknięcia i powroty.";
    default:
      return "Brakuje elementu technologicznego.";
  }
}
